/**
 * Project : workspace
 * File    : InventoryColorNavRoute.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package navigation.route.inventory.color

/**
 * Represents the inventory color nav route class.
 */

class InventoryColorNavRoute {
    companion object{
        const val ROOT = "color/"
        const val LIST = "${ROOT}list"
        const val DETAILS = "${ROOT}details"
        const val CREATE = "${ROOT}create"
        const val UPDATE = "${ROOT}update"
        const val SELECT = "${ROOT}select"
    }
}